import React from 'react';
import RoutePoint from './RoutePoints';
import Payments from './Payments';
import VehicleTypes from './VehicleTypes';
import styles from "../style.module.css";

const Steps = React.memo((props) => {
  const { nextPage, submitFormHandler, page} = props;
  return (
    <div className={styles.stepsContainer}>
      {
        page === 1 &&
        <RoutePoint onSubmit={nextPage} />
      }
      {
        page === 2 &&
        <VehicleTypes
          onSubmit={nextPage}
        />
      }
      {
        page === 3 &&
        <Payments
          onSubmit={submitFormHandler}
        />
      }
    </div>
  );
});

export default Steps;
